module.exports = __webpack_public_path__ + "img/05_wreck.3871ea09.png";